export class ClientEmail {
    client_email_id: number;
    client_no: number;
    email_desc: string;
    email_address: string;

    constructor(
        client_email_id: number,
        client_no: number,
        email_desc: string,
        email_address: string
    ) {
        this.client_email_id = client_email_id;
        this.client_no = client_no;
        this.email_desc = email_desc;
        this.email_address = email_address;
    } 
}